var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ViewCover',{staticStyle:{"height":"100%"}},[_c('Breadcrumb',[_c('div',{attrs:{"id":"guest_actions"}})]),_c('v-container',{staticClass:"px-1",attrs:{"fluid":""}},[_c('KeepAlive',{attrs:{"exclude":"Guest"}},[_c('v-card',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }